import api from './api'
export const pricingWorkspaceService = {
  load: () => api.get('/api/platform/billing/pricing/workspace'),
  saveDraft: (draft: unknown) => api.post('/api/platform/billing/pricing/product-draft', draft),
  simulate: (input: unknown) => api.post('/api/platform/billing/pricing/simulate', input),
}
